import AppLayout from '@components/layouts/appLayout';

import StoryImage from '../components/Image';
import { ImageNavigationOverlay } from '../components/ImageNavigationOverlay';
import { StoryFooter } from '../components/layout/StoryFooter';
import { StoryHeader } from '../components/layout/StoryHeader';
import { StoryWrapper } from '../components/layout/StoryWrapper';
import { StoryPageDisplay, StoryPageType } from '../enums';
import { Renderer as RendererType, Tester } from '../types';

export const Renderer: RendererType = ({ story, storyPage }) => {
    return (
        <AppLayout
            footerHasPointerEvents={false}
            footerPosition='absolute'
            headerPosition='absolute'
            header={
                <StoryHeader withExit story={story} storyPage={storyPage} />
            }
            body={
                <StoryWrapper>
                    <ImageNavigationOverlay />
                    <StoryImage storyPage={storyPage} />
                </StoryWrapper>
            }
            footer={
                <StoryFooter
                    storyPage={storyPage}
                    withCtas={false}
                    withNavigationButtons={false}
                    withVideoPlayerButtons={false}
                />
            }
        />
    );
};

export const tester: Tester = (display, storyPage) => {
    return {
        condition:
            display === StoryPageDisplay.Default &&
            storyPage.type === StoryPageType.Image,
        priority: 4,
    };
};

const rendererWithTester = { renderer: Renderer, tester };

export default rendererWithTester;
